module.exports = __webpack_public_path__ + "img/people-20.120c187c.png";